/**
 * @module pages
 * @package @geenius/adapters/react-mui
 * @description Public MUI page wrappers for the React adapter reference
 * surface.
 */

"use client";

import {
  type AdapterDetailPageProps,
  type AdaptersPageProps,
  AdapterDetailPage as ReferenceAdapterDetailPage,
  AdaptersPage as ReferenceAdaptersPage,
} from "@geenius/adapters/react";

export type { AdapterDetailPageProps, AdaptersPageProps };

export function AdapterDetailPage(props: AdapterDetailPageProps) {
  return <ReferenceAdapterDetailPage {...props} />;
}

export function AdaptersPage(props: AdaptersPageProps) {
  return <ReferenceAdaptersPage {...props} />;
}
